import React, { useState } from 'react';
import { Save, X } from 'lucide-react';

import { useToast } from './toastContext';

const EditNodeStatusModal = ({ node, onClose, onSave }) => {
    const toast = useToast();

    const [status, setStatus] = useState(node.status || 2);

    const [startDate, setStartDate] = useState(
        node.oplombirovanDate
            ? node.oplombirovanDate.split('.').reverse().join('-')
            : ''
    );

    const [validUntil, setValidUntil] = useState(
        node.oplombirovanValidUntil
            ? node.oplombirovanValidUntil.split('.').reverse().join('-')
            : ''
    );

    const isCommissioned = Number(status) === 1;

    const handleSave = () => {
        if (isCommissioned && !validUntil) {
            toast.warning(
                'Для статуса «Введен в эксплуатацию» необходимо указать дату окончания действия'
            );

            return;
        }

        onSave({
            status: Number(status),
            oplombirovanDate: isCommissioned ? startDate || null : null,
            oplombirovanValidUntil: isCommissioned ? validUntil || null : null
        });
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-md">
                <div className="px-4 py-3 border-b border-slate-700 flex items-center justify-between">
                    <h3 className="text-white font-semibold">
                        Статус узла: {node.name}
                    </h3>

                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-white"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-4 space-y-4">
                    <div>
                        <label className="block text-slate-400 text-xs mb-1">
                            Статус узла учета
                        </label>

                        <select
                            value={status}
                            onChange={(e) => setStatus(Number(e.target.value))}
                            className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                        >
                            <option value={1}>Введен в эксплуатацию</option>
                            <option value={2}>Ожидание оплаты</option>
                            <option value={3}>На поверке</option>
                            <option value={4}>Выведен из эксплуатации</option>
                        </select>
                    </div>

                    {isCommissioned ? (
                        <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700 space-y-3">
                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Дата ввода в эксплуатацию
                                </label>

                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm [&::-webkit-calendar-picker-indicator]:invert [&::-webkit-calendar-picker-indicator]:cursor-pointer"
                                />
                            </div>

                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Действительно до
                                </label>

                                <input
                                    type="date"
                                    value={validUntil}
                                    onChange={(e) => setValidUntil(e.target.value)}
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm [&::-webkit-calendar-picker-indicator]:invert [&::-webkit-calendar-picker-indicator]:cursor-pointer"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700">
                            <p className="text-slate-500 text-xs">
                                Даты действия сохраняются только для статуса
                                «Введен в эксплуатацию».
                            </p>
                        </div>
                    )}
                </div>

                <div className="px-4 py-3 border-t border-slate-700 flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg text-sm"
                    >
                        Отмена
                    </button>

                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-sm flex items-center gap-2"
                    >
                        <Save className="w-4 h-4" />
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditNodeStatusModal;